import { DivisiResponse } from "../../../../models/Divisi";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function adminJob(
  JOB_ID: number
): Promise<AdminJobDetailResponse> {
  const res = await ApiClient.get(`/AdminJobDetail?JOB_ID=${JOB_ID}`);
  return res.data[0];
}

export const useFetchAdminJob = mutationWrapper(adminJob);
